import {
  CardHeaderShell,
  CardStatsRow,
  GradesAndSalaryRow,
  GradesStat,
  InlineNameAndDistrict,
  LocationStat,
  LocationStatNoDistance,
  PrincipalStat,
  SalaryScheduleStat,
  SchoolTypeStat,
  StackedNameAndDistrict,
  StudentCountStat,
  TagsRow,
} from "@/components/shared/school/school-details/school-details-header-blocks";
import { SchoolDetailsHeaderProps } from "@/lib/types/schools.types";

export default function SchoolDetailsHeader({
  schoolData,
  stateConfig,
  schoolLinkTarget,
}: SchoolDetailsHeaderProps) {
  return (
    <CardHeaderShell schoolData={schoolData}>
      <InlineNameAndDistrict
        schoolData={schoolData}
        stateConfig={stateConfig}
        schoolLinkTarget={schoolLinkTarget}
      />
      <CardStatsRow>
        <LocationStat schoolData={schoolData} />
        <StudentCountStat schoolData={schoolData} />
        <SchoolTypeStat schoolData={schoolData} />
        <PrincipalStat schoolData={schoolData} />
      </CardStatsRow>
      <GradesAndSalaryRow>
        <GradesStat schoolData={schoolData} />
        <SalaryScheduleStat schoolData={schoolData} />
      </GradesAndSalaryRow>
      <TagsRow schoolData={schoolData} />
    </CardHeaderShell>
  );
}

export function SchoolDetailsHeaderCompact({
  schoolData,
  stateConfig,
  schoolLinkTarget,
}: SchoolDetailsHeaderProps) {
  return (
    <CardHeaderShell schoolData={schoolData}>
      <InlineNameAndDistrict
        schoolData={schoolData}
        stateConfig={stateConfig}
        schoolLinkTarget={schoolLinkTarget}
      />
      <CardStatsRow>
        <LocationStat schoolData={schoolData} />
        <PrincipalStat schoolData={schoolData} />
      </CardStatsRow>
      <GradesAndSalaryRow>
        <GradesStat schoolData={schoolData} />
        <SalaryScheduleStat schoolData={schoolData} />
      </GradesAndSalaryRow>
      <TagsRow schoolData={schoolData} />
    </CardHeaderShell>
  );
}

export function SchoolDetailsSavedSchools({
  schoolData,
  stateConfig,
  schoolLinkTarget,
}: SchoolDetailsHeaderProps) {
  return (
    <CardHeaderShell schoolData={schoolData}>
      <StackedNameAndDistrict
        schoolData={schoolData}
        stateConfig={stateConfig}
        schoolLinkTarget={schoolLinkTarget}
      />
      <CardStatsRow>
        <LocationStatNoDistance schoolData={schoolData} />
        <PrincipalStat schoolData={schoolData} />
      </CardStatsRow>
      <GradesAndSalaryRow>
        <GradesStat schoolData={schoolData} />
        <SalaryScheduleStat schoolData={schoolData} />
      </GradesAndSalaryRow>
    </CardHeaderShell>
  );
}

export function SchoolDetailsHeaderMinimal({
  schoolData,
  stateConfig,
  schoolLinkTarget,
}: SchoolDetailsHeaderProps) {
  return (
    <CardHeaderShell schoolData={schoolData}>
      <StackedNameAndDistrict
        schoolData={schoolData}
        stateConfig={stateConfig}
        schoolLinkTarget={schoolLinkTarget}
      />
      <div className="lg:hidden">
        <CardStatsRow>
          <LocationStat schoolData={schoolData} />
          <PrincipalStat schoolData={schoolData} />
        </CardStatsRow>
      </div>
      <TagsRow schoolData={schoolData} />
    </CardHeaderShell>
  );
}
